// Date format the /embedded_experiences list expects in its `date` filter.
export const LIST_DATE_PARAM_FORMAT = "MM-DD-YYYY"

// Date shown in the search bar's "When" field.
export const SEARCH_DATE_DISPLAY_FORMAT = "MM/DD/YYYY"

export const MIN_SEARCH_GUESTS = 1
export const MAX_SEARCH_GUESTS = 99

// Card price suffix per pricing type (booking_widget.card.price_suffix.*). Ticketed listings are
// priced per ticket, i.e. per person.
export const PRICE_SUFFIX_PRICING_TYPES = ["charge_flat_rate", "set_minimum_rate", "charge_per_person"]

// postMessage contract with public/booking-widget.js (a plain script, so it repeats these strings).
// The widget announces itself with `ready`; a host page that can close the popup answers
// `close_supported`, and the widget then shows its own X, which sends `close` on Exit.
export const EMBED_MESSAGE_SOURCE = { widget: "dsg-booking-widget", host: "dsg-booking-widget-host" }
export const EMBED_MESSAGES = { ready: "ready", closeSupported: "close_supported", close: "close" }

// The API holds the cart's places (10 minutes from the last Add to Cart, extensions_left "Yes"
// answers). "Are you still shopping?" asks with CART_HOLD_PROMPT_SECONDS left.
export const CART_HOLD_PROMPT_SECONDS = 60

// A cart item's hold, as the API reports it: held until the cart's expires_at, expired with the
// cart's timer, lost when renewal found the places gone, booked once Pay used it.
export const CART_HOLD_STATUSES = { held: "held", expired: "expired", lost: "lost", booked: "booked" }

// Cart error keys (message keys of a refused cart call or Pay).
export const CART_ERRORS = {
  holdNotFound: "hold_not_found",
  holdExpired: "hold_expired",
  holdNotExpired: "hold_not_expired",
  holdMismatch: "hold_mismatch",
  extensionLimit: "hold_extension_limit"
}

// "Choose another time" on a cart item opens its experience with ?item=<cartId>: the booking panel then
// changes that item instead of adding one. CART_ONLY_ITEM_FIELDS are the cart's own, not a choice.
export const CART_ITEM_QUERY = "item"
export const CART_ONLY_ITEM_FIELDS = ["cartId", "holdId", "holdStatus", "holdError", "addOns", "amount"]

// A booking waiting for the guide to accept it (details.status), e.g. one within 24 hours in an order.
export const BOOKING_REQUESTED_STATUS = "requested"

// An order of several cart items (POST /orders) as the API reports it, and the keys of a refused
// order call that checkout acts on.
export const ORDER_STATUSES = { pendingPayment: "pending_payment", paid: "paid", expired: "expired" }
export const ORDER_ERRORS = {
  orderExpired: "order_expired",
  paymentNotAuthorized: "payment_not_authorized",
  slotUnavailable: "slot_unavailable",
  ticketsUnavailable: "tickets_unavailable"
}

// An item refused with one of these keys can be booked at another time ("Choose another time").
export const ORDER_ERRORS_FOR_ANOTHER_TIME = [ORDER_ERRORS.slotUnavailable, ORDER_ERRORS.ticketsUnavailable]

// The order's charge today may differ from the checkout's own figure by rounding: the server shares
// the card fee between the bookings cent by cent. A bigger difference is shown before charging.
export const ORDER_CHARGE_TOLERANCE = 0.01

// The checkout fields kept for the cart through a reload or an expired reservation: the guest's
// contact details and the payment option and method. Never the card, its name, country or ZIP.
export const SAVED_CHECKOUT_FIELDS = [
  "first_name",
  "last_name",
  "email",
  "phone_number",
  "accessibility_enabled",
  "accessibility_notes",
  "paymentOption",
  "paymentMethod"
]

// A tab the guest comes back to reads the API's cart again; switching tabs fires both focus and
// visibilitychange, so reads closer together than this are one.
export const CART_REFETCH_GAP_MS = 1000
